import { useTranslation } from 'react-i18next';
import { useAuth } from '../lib/auth';
import { pick } from '../i18n';
import { Badge, PageHeader } from '../components/ui';
import { Dashboard } from '../modules/dashboard/Dashboard';

/** Home: the dashboard for everyone; administrators also see which build and modules this instance runs. */
export function HomePage() {
  const { t, i18n } = useTranslation();
  const { me, config, can } = useAuth();
  if (!me || !config) return null;
  const business = config.enabled_modules.filter((m) => m !== 'core');
  return (
    <div>
      <PageHeader title={t('home.welcome', { name: pick(i18n.language, me.display_name_en, me.display_name_ar) })} subtitle={pick(i18n.language, config.display_name_en, config.display_name_ar)} />
      <Dashboard />
      {can('settings') && (
        <details className="card mt-4 p-4 text-sm">
          <summary className="cursor-pointer font-medium">{t('home.instance')}</summary>
          <div className="mt-3 grid gap-4 md:grid-cols-3">
            <div>
              <div className="label">{t('home.instance')}</div>
              <div dir="auto">{pick(i18n.language, config.display_name_en, config.display_name_ar)}</div>
              <div className="text-xs text-neutral-500">{config.slug} · {config.instance_kind}</div>
            </div>
            <div>
              <div className="label">{t('home.version')}</div>
              <div>{config.version}</div>
              <div className="text-xs text-neutral-500">seed {config.seed_pack_version}</div>
            </div>
            <div>
              <div className="label">{t('home.modules')}</div>
              {business.length === 0 ? <p className="text-neutral-500">{t('home.noModules')}</p> : <div className="flex flex-wrap gap-1">{business.map((m) => <Badge key={m}>{m}</Badge>)}</div>}
            </div>
          </div>
        </details>
      )}
    </div>
  );
}
